module.exports = __webpack_public_path__ + "img/register_icon.82f69f65.png";